(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["featured-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('featured-badge')) {
    customElements.define(
      'featured-badge',
      class FeaturedBadge extends HTMLElement {
        connectedCallback() {
          // Move the badge inside the product image area so positions
          // are measured against the image, not the whole card.
          const card = this.closest('product-card, .product-card') || this.parentElement;
          if (!card) return;

          const gallery = card.querySelector('.card-gallery, [class*="card-gallery"]');
          if (gallery && !gallery.contains(this)) {
            gallery.classList.add('featured-badge-host');
            gallery.appendChild(this);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
